import { useMutation } from 'react-query';
import { updateDemandAttachments } from 'src/services/api/demands';

function useUpdateDemandAttachment() {
  return useMutation(({ demand, data }) => updateDemandAttachments(demand, data));
}

export default useUpdateDemandAttachment;
